/**
 * Seller address API endpoint schemas
 *
 * Zod schemas and types for /api/checkout/seller-address
 */
import { z } from 'zod';

// Request schema
export const SellerAddressQuerySchema = z.object({
  listingId: z.coerce.number().int().positive(),
});

export type SellerAddressQuery = z.infer<typeof SellerAddressQuerySchema>;

// Response component schemas
export const SellerAddressDetailSchema = z.object({
  name: z.string(),
  line1: z.string(),
  line2: z.string(),
  city: z.string(),
  state: z.string(),
  postal_code: z.string(),
  country: z.string(),
});

export type SellerAddressDetail = z.infer<typeof SellerAddressDetailSchema>;

// Response schemas
export const SellerAddressResponseSchema = z.object({
  success: z.literal(true),
  address: SellerAddressDetailSchema,
  warning: z.string().optional(),
});

export type SellerAddressResponse = z.infer<typeof SellerAddressResponseSchema>;

export const SellerAddressErrorSchema = z.object({
  success: z.literal(false),
  error: z.string(),
  message: z.string().optional(),
});

export type SellerAddressError = z.infer<typeof SellerAddressErrorSchema>;
